export const USDCOUNTRIES: string[] = [
  'US',
  'BH',
  'DZ',
  'EG',
  'IL',
  'JO',
  'LB',
  'LY',
  'MA',
  'OM',
  'PS',
  'QA',
  'SA',
  'AE',
  'BQ',
  'AI',
  'AG',
  'AR',
  'AW',
  'BS',
  'BB',
  'BZ',
  'BM',
  'BO',
  'BR',
  'KY',
  'CL',
  'CO',
  'CR',
  'CU',
  'CW',
  'DM',
  'DO',
  'EC',
  'SV',
  'GF',
  'GD',
  'GP',
  'GT',
  'GY',
  'HT',
  'HN',
  'JM',
  'MQ',
  'MX',
  'MS',
  'NI',
  'PA',
  'PY',
  'PE',
  'PR',
  'BL',
  'KN',
  'LC',
  'MF',
  'PM',
  'VC',
  'SX',
  'SR',
  'TT',
  'TC',
  'UY',
  'VE',
  'VG',
  'VI',
  'CA',
]

export default USDCOUNTRIES
